module.exports = __webpack_public_path__ + "static/media/15.e68eaf05.jpeg";